var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 0.0234375C28.6538 0.0234375 0 28.6772 0 64.0234C0 99.3697 28.6538 128.023 64 128.023C99.3462 128.023 128 99.3697 128 64.0234C127.962 28.6931 99.3304 0.06165 64 0.0234375ZM64 117.357C34.5448 117.357 10.6667 93.4786 10.6667 64.0234C10.6667 34.5683 34.5448 10.6901 64 10.6901C93.4552 10.6901 117.333 34.5683 117.333 64.0234C117.301 93.4652 93.4418 117.324 64 117.357ZM93.6085 33.1941C95.356 32.929 97.1372 33.3693 98.56 34.4181C99.9872 35.4636 100.94 37.0335 101.209 38.7821C101.478 40.5307 101.041 42.3145 99.9947 43.7408L64.2613 92.2048C63.1737 93.6488 61.5513 94.5951 59.7589 94.8308C57.9665 95.0666 56.1546 94.5719 54.7307 93.4581L29.2213 73.0528C26.4363 70.7252 26.0229 66.5982 28.2908 63.7644C30.5588 60.9306 34.676 60.4296 37.5573 62.6368L57.648 78.7114L89.2427 35.8314C90.2904 34.4079 91.8609 33.4592 93.6085 33.1941Z",
    fill: "#29CC8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.3acd21b874ad16f4672884cccf8ce476.svg";
export { ForwardRef as ReactComponent };